import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import {
  KpiChartBackground,
  KpiChartCont,
  KpiChartTitle,
  KpiResultsCont,
  CurrentKpiChartBackground,
  KpiDescCont,
  KpiDesc,
  CurrentKpiDesc,
  KPIMeterCont,
} from './KpiResults.styles';
import PageSection from '../../HOC/PageSection/PageSection';
import { IKpiAnalysisResults } from '../../services/reports';
import KPIHistoryChart from '../KPIHistoryChart/KPIHistoryChart';
import KPIMeter from '../KPIMeter/KPIMeter';

interface IKpiResults {
  kpiAnalysisResults: IKpiAnalysisResults;
}

const KpiResults: FC<IKpiResults> = ({
  kpiAnalysisResults: { description, current, historicalBenchmarks },
}) => {
  const { i18n, t } = useTranslation();
  const { kpi = 0, rating, target } = current;
  const isExpanded = false;

  const { language } = i18n;

  const hasHistoricalBenchmarks =
    !_.isNil(historicalBenchmarks) && !_.isEmpty(historicalBenchmarks);

  return (
    <PageSection title={t('report.kpi.kpi')} width={hasHistoricalBenchmarks ? 'full' : 'half'}>
      <>
        <KpiResultsCont id="KpiResultsCont">
          <KpiDescCont id="KpiDescCont">
            <KpiDesc
              id="KpiDesc"
              isExpanded
              data-testid={isExpanded ? 'expandedDesc' : 'notExpandedDesc'}
            >
              {description}
            </KpiDesc>
          </KpiDescCont>
          <KpiChartCont id="KpiChartCont">
            <CurrentKpiChartBackground id="CurrentKpiChartBackground">
              <KpiChartTitle id="KpiChartTitle">{t('report.kpi.current')}</KpiChartTitle>
              <KPIMeterCont>
                <KPIMeter value={kpi} target={target} />
              </KPIMeterCont>
              <CurrentKpiDesc id="CurrentKpiDesc">{rating.description}</CurrentKpiDesc>
            </CurrentKpiChartBackground>
            {hasHistoricalBenchmarks ? (
              <KpiChartBackground id="KpiChartBackground">
                <KpiChartTitle id="KpiChartTitle">{t('report.kpi.history')}</KpiChartTitle>
                <KPIHistoryChart
                  data={historicalBenchmarks.map(
                    ({ survey: { endDate, type }, kpiAnalysisResult: { score } }) => ({
                      endDate,
                      kpi: score,
                      type,
                    })
                  )}
                  {...{ language, target }}
                />
              </KpiChartBackground>
            ) : null}
          </KpiChartCont>
        </KpiResultsCont>
      </>
    </PageSection>
  );
};

export default KpiResults;
